import React from 'react';
import {Flex} from "antd";

interface BriefDescriptionItemProps {
  title: string,
  value: string,
}

export default function BriefDescriptionItem({title, value}: BriefDescriptionItemProps) {
  return (
    <Flex vertical>
      <div className={'brief-description__title'}>
        {title}
      </div>
      <div className={'brief-description__text'}>
        {value}
      </div>
    </Flex>
  )
}
